import * as React from 'react';

import { LinkButton, useDeviceType } from '@cian/ui-kit';
import { IExtraBtnProps } from '../../../../containers/QuizCompletedContainer/types';

export const IpotekaLinkButton: React.FC<React.PropsWithChildren<IExtraBtnProps>> = ({ onClick }) => {
  const deviceType = useDeviceType();

  return (
    <LinkButton
      href="/ipoteka/calculator/"
      target="_blank"
      rel="noreferrer"
      fullWidth={deviceType !== 'desktop'}
      onClick={onClick}
    >
      Рассчитать ипотеку
    </LinkButton>
  );
};

IpotekaLinkButton.displayName = 'IpotekaLinkButton';
